<div class="node-card" [class.has-warning]="node.hasWarning && !node.isValid" [class.is-valid]="node.isValid">
  <div class="node-card-header" *ngIf="showHeader">
    <div class="node-identity">
      <span class="node-number" *ngIf="showHeaderIndex">{{ index + 1 }}</span>
      <span class="node-type-badge" [ngClass]="getBadgeClass()" *ngIf="showHeaderTypeBadge">{{ node.type }}</span>
      <span class="node-label" *ngIf="showHeaderLabel">{{ node.label }}</span>
    </div>
    <div class="node-actions-header" *ngIf="showHeaderActions">
      <button class="menu-btn" *ngIf="showTestAction" (click)="handleTestNode()">&#9654; {{ headerActionLabel('test', 'Test') }}</button>
      <button class="menu-btn" *ngIf="showDuplicateAction" (click)="handleDuplicateNode()">{{ headerActionLabel('duplicate', 'Duplicate') }}</button>
      <button class="menu-btn danger" *ngIf="showDeleteAction" (click)="handleDeleteNode()">{{ headerActionLabel('delete', 'Delete') }}</button>
    </div>
  </div>

  <div class="flow-step-strip" *ngIf="showFlowContext">
    <span class="fss-step">{{ gateLabelPrefix }} {{ index + 1 }}</span>
    <span class="fss-sep">{{ flowContextSeparator }}</span>
    <span class="fss-type" [class.fss-parallel]="node.type === 'PARALLEL'">
      {{ decisionRuleSummary() }}
    </span>
  </div>

  <div class="panels-grid" *ngIf="visiblePanels.length">
    <div
      class="panel"
      *ngIf="isPanelVisible('triggers')"
      [class.panel-hover]="hoveredPanel === 'triggers'"
      (mouseenter)="hoveredPanel = 'triggers'"
      (mouseleave)="hoveredPanel = null">
      <div class="panel-header">
        <span class="panel-title">
          {{ triggerPanelTitle }}
          <ng-container *ngIf="showPanelCount('triggers')"> - {{ node.triggerConditions.length }}</ng-container>
        </span>
      </div>
      <div class="trigger-list">
        <div
          class="trigger-row hover-item"
          *ngFor="let tc of node.triggerConditions; let i = index"
          [class.item-hovered]="hoveredTrigger === i"
          (mouseenter)="hoveredTrigger = i"
          (mouseleave)="hoveredTrigger = null">
          <input
            *ngIf="showField('triggers', 'field')"
            class="trigger-field"
            [value]="tc.field"
            [readOnly]="!isEditable('triggers', 'field')"
            [placeholder]="inputPlaceholder('triggers', 'field')"
            (blur)="updateTrigger(tc.id, 'field', $event)"
            (click)="$event.stopPropagation()"/>
          <select
            *ngIf="showField('triggers', 'operator')"
            class="trigger-op"
            [disabled]="!isEditable('triggers', 'operator')"
            (change)="updateTrigger(tc.id, 'operator', $event)">
            <option *ngFor="let op of operators" [value]="op" [selected]="op === tc.operator">{{ op }}</option>
          </select>
          <input
            *ngIf="showField('triggers', 'value')"
            class="trigger-val"
            type="number"
            [value]="tc.value"
            [readOnly]="!isEditable('triggers', 'value')"
            [placeholder]="inputPlaceholder('triggers', 'value')"
            (blur)="updateTrigger(tc.id, 'value', $event)"
            (click)="$event.stopPropagation()"/>
          <span class="trigger-currency" *ngIf="showField('triggers', 'currency')">{{ tc.currency }}</span>
          <button
            class="item-remove small"
            *ngIf="node.triggerConditions.length > 1 && showField('triggers', 'removeAction') && isEditable('triggers', 'removeAction')"
            (click)="removeTrigger(i); $event.stopPropagation()">&#x2715;</button>
        </div>
      </div>
      <div class="live-match-preview" *ngIf="readFlag(config?.panels?.triggers?.livePreview?.visible, true)">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <circle cx="6" cy="6" r="5" fill="currentColor" fill-opacity="0.15"/>
          <path d="M3.5 6l2 2 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="preview-bold">{{ readText(config?.panels?.triggers?.livePreview?.title, 'Live match preview') }}</span>
        <span class="preview-text">{{ readText(config?.panels?.triggers?.livePreview?.text, 'Would match ~12% of last 30 days of requests (n=147)') }}</span>
      </div>
      <button
        class="add-condition-btn"
        *ngIf="readFlag(config?.panels?.triggers?.allowAdd, true)"
        (click)="addCondition()">{{ actionLabel('triggers', 'add', '+ Add AND / OR condition') }}</button>
    </div>

    <div
      class="panel"
      *ngIf="isPanelVisible('approvers')"
      [class.panel-hover]="hoveredPanel === 'approvers'"
      (mouseenter)="hoveredPanel = 'approvers'"
      (mouseleave)="hoveredPanel = null">
      <div class="panel-header">
        <span class="panel-title">
          {{ approverPanelTitle }}
          <ng-container *ngIf="showPanelCount('approvers')"> - {{ node.approvers.length }}</ng-container>
        </span>
      </div>
      <div class="approver-list">
        <div
          class="approver-item hover-item"
          *ngFor="let approver of node.approvers; let i = index"
          [class.item-hovered]="hoveredApprover === i"
          (mouseenter)="hoveredApprover = i"
          (mouseleave)="hoveredApprover = null">
          <div class="approver-avatar" [class.role-avatar]="approver.type === 'role'">{{ getInitials(approver.name) }}</div>
          <div class="approver-info">
            <div class="approver-name">{{ approver.name }}</div>
            <div class="approver-meta" *ngIf="approver.type === 'role'">ROLE - {{ approver.memberCount }} members</div>
            <div class="approver-meta mono" *ngIf="approver.type === 'user'">{{ approver.email || 'user' }}</div>
          </div>
          <button
            class="item-remove"
            *ngIf="isEditable('approvers', 'removeAction')"
            (click)="removeApprover(i); $event.stopPropagation()">&#x2715;</button>
        </div>
      </div>
      <div
        class="add-approver-container"
        *ngIf="readFlag(config?.panels?.approvers?.allowQuickAdd, true)"
        (mouseenter)="showApproverMenu = true"
        (mouseleave)="showApproverMenu = false">
        <button class="add-inline-btn">{{ actionLabel('approvers', 'add', '+ Add approver') }}</button>
        <div class="approver-hover-menu" *ngIf="showApproverMenu">
          <div class="menu-header">{{ readText(config?.panels?.approvers?.quickAddMenuTitle, 'Quick Add Role') }}</div>
          <button
            class="menu-item"
            *ngFor="let option of quickApproverOptions"
            (click)="addPredefinedApprover(option.name, option.type, option.memberCount)">
            <div class="role-icon" [ngClass]="quickOptionToneClass(option)">{{ quickOptionAvatar(option) }}</div>
            <div class="role-details">
              <span class="role-name">{{ option.name }}</span>
              <span class="role-meta">{{ quickOptionMeta(option, 'ROLE') }}</span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <div
      class="panel"
      *ngIf="isPanelVisible('decisionRule')"
      [class.panel-hover]="hoveredPanel === 'decision'"
      (mouseenter)="hoveredPanel = 'decision'"
      (mouseleave)="hoveredPanel = null">
      <div class="panel-header"><span class="panel-title">{{ decisionRulePanelTitle }}</span></div>
      <div class="decision-rule-name" *ngIf="showField('decisionRule', 'type')">{{ node.decisionRule.type }}</div>
      <div class="decision-min hover-item" *ngIf="node.decisionRule.type === 'N_OF_M' && showField('decisionRule', 'minApprovals')">
        min approvals
        <input type="number" class="inline-num-input" [value]="node.decisionRule.minApprovals" [disabled]="!isEditable('decisionRule', 'minApprovals')" (change)="updateDecisionRule('minApprovals', $event)"/>
        of
        <input type="number" class="inline-num-input" [value]="node.decisionRule.totalApprovers" [disabled]="!isEditable('decisionRule', 'totalApprovers')" (change)="updateDecisionRule('totalApprovers', $event)"/>
      </div>
      <div class="decision-desc" *ngIf="node.decisionRule.description && showField('decisionRule', 'description')">{{ node.decisionRule.description }}</div>
    </div>

    <div
      class="panel"
      *ngIf="isPanelVisible('delegation')"
      [class.panel-hover]="hoveredPanel === 'delegation'"
      (mouseenter)="hoveredPanel = 'delegation'"
      (mouseleave)="hoveredPanel = null">
      <div class="panel-header">
        <span class="panel-title">{{ delegationPanelTitle }}</span>
        <span class="badge-new" *ngIf="delegationSupported() && readFlag(config?.panels?.delegation?.showNewBadge, true)">{{ readText(config?.panels?.delegation?.newBadgeText, 'NEW') }}</span>
      </div>
      <ng-container *ngIf="delegationSupported(); else noDeleg">
        <div class="approver-list">
          <div
            class="approver-item hover-item"
            *ngFor="let du of node.delegationUsers; let i = index"
            [class.item-hovered]="hoveredDelegation === i"
            (mouseenter)="hoveredDelegation = i"
            (mouseleave)="hoveredDelegation = null">
            <div class="approver-avatar role-avatar">{{ getInitials(du.name) }}</div>
            <div class="approver-info">
              <div class="approver-name">{{ du.name }}</div>
              <div class="approver-meta">{{ du.description || (du.type + ' - ' + du.memberCount + ' members') }}</div>
            </div>
            <button
              class="item-remove"
              *ngIf="isEditable('delegation', 'removeAction')"
              (click)="removeDelegate(i); $event.stopPropagation()">&#x2715;</button>
          </div>
        </div>
        <div
          class="add-approver-container"
          *ngIf="readFlag(config?.panels?.delegation?.allowQuickAdd, true)"
          (mouseenter)="showDelegationMenu = true"
          (mouseleave)="showDelegationMenu = false">
          <button class="add-inline-btn">{{ actionLabel('delegation', 'add', '+ Add delegate') }}</button>
          <div class="approver-hover-menu" *ngIf="showDelegationMenu">
            <div class="menu-header">{{ readText(config?.panels?.delegation?.quickAddMenuTitle, 'Quick Add Delegate') }}</div>
            <button
              class="menu-item"
              *ngFor="let option of quickDelegationOptions"
              (click)="addPredefinedDelegation(option.name, option.type, option.memberCount, option.description)">
              <div class="role-icon" [ngClass]="quickOptionToneClass(option)">{{ quickOptionAvatar(option) }}</div>
              <div class="role-details">
                <span class="role-name">{{ option.name }}</span>
                <span class="role-meta">{{ quickOptionMeta(option, 'USER') }}</span>
              </div>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-template #noDeleg>
        <div class="no-meta">{{ readText(config?.panels?.delegation?.notAvailableText, 'Not available for this node type') }}</div>
      </ng-template>
    </div>

    <div
      class="panel"
      *ngIf="isPanelVisible('sla')"
      [class.panel-hover]="hoveredPanel === 'sla'"
      (mouseenter)="hoveredPanel = 'sla'"
      (mouseleave)="hoveredPanel = null">
      <div class="panel-header"><span class="panel-title">{{ slaPanelTitle }}</span></div>
      <div class="sla-grid">
        <div class="sla-field hover-item" *ngIf="showField('sla', 'reminderHours')">
          <div class="sla-label">{{ slaLabel('reminderHours', 'REMINDER') }}</div>
          <div class="sla-value">
            <input type="number" class="inline-num-input large" [value]="node.sla.reminderHours" [disabled]="!isEditable('sla', 'reminderHours')" (change)="updateSLA('reminderHours', $event)"/>h
          </div>
        </div>
        <div class="sla-field hover-item" *ngIf="showField('sla', 'maxEscalations')">
          <div class="sla-label">{{ slaLabel('maxEscalations', 'MAX ESC') }}</div>
          <div class="sla-value">
            <input type="number" class="inline-num-input large" [value]="node.sla.maxEscalations" [disabled]="!isEditable('sla', 'maxEscalations')" (change)="updateSLA('maxEscalations', $event)"/>
          </div>
        </div>
        <div class="sla-field hover-item" *ngIf="showField('sla', 'onTimeout')">
          <div class="sla-label">{{ slaLabel('onTimeout', 'ON TIMEOUT') }}</div>
          <div class="sla-value timeout" [class.escalate]="node.sla.onTimeout === 'ESCALATE'">
            <select class="inline-select" [disabled]="!isEditable('sla', 'onTimeout')" (change)="updateSLA('onTimeout', $event)">
              <option *ngFor="let option of timeoutOptions()" [value]="option" [selected]="node.sla.onTimeout === option">{{ option }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="escalation-chain-section" *ngIf="node.sla.escalationChain?.length && showField('sla', 'escalationChain')">
        <div class="sla-section-label">{{ slaLabel('escalationChain', 'ESCALATION CHAIN') }}</div>
        <div class="escalation-chain">
          <ng-container *ngFor="let step of node.sla.escalationChain; let last = last">
            <div class="esc-dot" [class.esc-dot-last]="last"></div>
            <span class="esc-line" *ngIf="!last">-</span>
            <span class="esc-name">{{ step.name }}</span>
            <span class="esc-line" *ngIf="!last">-</span>
          </ng-container>
          <span class="esc-worst" *ngIf="node.sla.worstCaseHours && showField('sla', 'worstCaseHours')">~{{ node.sla.worstCaseHours }}h {{ slaLabel('worstCaseHours', 'worst') }}</span>
        </div>
      </div>
    </div>

    <div
      class="panel"
      *ngIf="isPanelVisible('metadata')"
      [class.panel-hover]="hoveredPanel === 'metadata'"
      (mouseenter)="hoveredPanel = 'metadata'"
      (mouseleave)="hoveredPanel = null">
      <div class="panel-header"><span class="panel-title">{{ metadataPanelTitle }}</span></div>
      <div class="metadata-grid" *ngIf="node.metadata; else noMeta">
        <div class="meta-row" *ngIf="showField('metadata', 'id')"><span class="meta-key">{{ metadataLabel('id', 'ID') }}</span><span class="meta-val mono">{{ node.metadata.id }}</span></div>
        <div class="meta-row" *ngIf="showField('metadata', 'createdAt')"><span class="meta-key">{{ metadataLabel('createdAt', 'Created') }}</span><span class="meta-val">{{ node.metadata.createdAt }} by {{ node.metadata.createdBy }}</span></div>
        <div class="meta-row" *ngIf="showField('metadata', 'lastEdited')"><span class="meta-key">{{ metadataLabel('lastEdited', 'Last edited') }}</span><span class="meta-val">{{ node.metadata.lastEdited }} - {{ node.metadata.editCount }} changes</span></div>
        <div class="meta-row" *ngIf="showField('metadata', 'usedBy')"><span class="meta-key">{{ metadataLabel('usedBy', 'Used by') }}</span><span class="meta-val">{{ node.metadata.usedBy }}</span></div>
      </div>
      <ng-template #noMeta><div class="no-meta">{{ readText(config?.panels?.metadata?.emptyText, 'No metadata yet') }}</div></ng-template>
    </div>
  </div>
</div>
